import {
  Box,
  Button,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  FormControl,
  FormControlLabel,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AlertComplete from "components/ui/alert-complete";
import { maxLen } from "assets/js/common";
import axios from "axios";
import { useHistory } from "react-router-dom";

export default function DrawerReceipt(props) {
  const { open, handleDrawerClose, callback } = props;

  const history = useHistory();
  const [receiptNum, setReceiptNum] = useState("");
  const [alertMode, setAlertMode] = useState("");
  const [alert, setAlert] = useState(false);
  // const [open, setOpen] = useState(false);
  const [drawerSave, setDrawerSave] = useState(false);

  const onSubmit = (data) => {
    axios
      .get("/api/mb/receipt/save-point", {
        params: {
          receiptNo: data.no,
        },
      })
      .then((res) => {
        setAlertMode("111");
        setAlert(true);
      })
      .catch((error) => {
        setAlertMode("valid");
        setAlert(true);
      });
  };

  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      no: "",
    },
  });

  window.appBackKeyHandle = () => {
    if (alert) {
      setAlert(false);
      if (alertMode != "valid") {
        setDrawerSave(false);
        callback();
      }
    } else if (open) {
      handleDrawerClose();
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleDrawerClose}
        className="drawer-common-bottom size-high title-center point-save"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="drawer-head">
            <h3>영수증 추후 적립</h3>
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={handleDrawerClose}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </div>

          <div className="drawer-body">
            <Box className="box-type-7">
              <FormControl>
                <OutlinedInput
                  type="tel"
                  {...register("no", {
                    required: true,
                  })}
                  inputProps={{
                    maxLength: 16,
                  }}
                  onChange={(e) => {
                    let text = (e.target.value = e.target.value.replace(
                      /[^0-9]/gi,
                      ""
                    ));
                    setValue("no", maxLen(text, 16));
                  }}
                  placeholder="영수증의 바코드 번호를 직접 입력하세요"
                  aria-describedby="error-no"
                />
              </FormControl>
              {errors.no?.type === "required" && (
                <FormHelperText id="error-no" className="error">
                  영수증 번호를 입력해주세요.
                </FormHelperText>
              )}
              <p className="save-info">
                미적립 영수증이 있다면? 종이영수증의 하단 바코드 번호를
                입력하시면 포인트가 적립됩니다.
              </p>
            </Box>
          </div>
          <div className="drawer-foot">
            {/* <Button color="primary" variant="contained" onClick={registPoint}>
             */}
            <Button color="primary" variant="contained" type="submit">
              입력 완료
            </Button>
          </div>
        </form>
      </Drawer>
      {alertMode == "valid" ? (
        <>
          <AlertComplete
            open={alert}
            handleAlertClose={() => setAlert(false)}
            text={"잘못된 영수증입니다. 영수증 번호를 정확히 입력해주세요."}
            action={() => {
              setAlert(false);
              // document.querySelector("#cont").focus();
            }}
          />
        </>
      ) : (
        <>
          <AlertComplete
            open={alert}
            handleAlertClose={() => setAlert(false)}
            text={"영수증 포인트가 적립되었습니다. 포인트 내역을 확인해주세요."}
            action={() => {
              setAlert(false);
              setDrawerSave(false);
              callback();
            }}
          />
        </>
      )}
    </>
  );
}
